<template>
  <div class="bot-response">
    <span>Bot Suggestion</span><br />
    <div class="bot-actions">
      <select v-model="intent" ref="selectedIntent" class="form-control">
        <option value=""></option>
        <option v-for="(value, key) in allIntents" :key="key" :value="key">{{key}}</option>
        <option value="other">Other</option>
      </select>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <input v-if="showNewIntentField" placeholder="New Intent" class="form-control" type="text" name="new-intent" v-model="newIntent" />
      <span v-if="!showNewIntentField">{{message}}</span>
      <i class="fa fa-check-circle" title="Accept" @click="validate(index)" />
      <!-- <i class="fa fa-times-circle" title="Reject" @click="removeEntity(intent)" /> -->
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'app-bot',
    props: ['bot', 'botIntent', 'index', 'entities', 'botLanguage'],
    methods: {
      validate(index) {
        const intent = this.intent === 'other' ? this.newIntent : this.intent;
        const message = this.newIntent ? '' : this.message;
        if (!this.$refs.selectedIntent.value || !intent) {
          this.$emit('showResponse', 'Invalid intent', 'error');
          return;
        }
        this.$emit('classify', index, intent, message, this.botLanguage || 'eng', !!this.newIntent);
      },

      /**
       * invalidate an entity and use the generic message that doesn't require entity
       * @param {string} intent - the intent of the message
       */
      // removeEntity(intent) {
      //   this.message = this.allIntents[intent].withoutentity[this.botLanguage || 'eng'];
      // },

      /**
       * @description format the message that shows for the user
       * @param {object}
       * @param {string} botMessage
       */
      showMessage(entities, botMessage, intent) {
        const lang = this.botLanguage || 'eng';
        if (intent && this.allIntents[intent]) {
          if (entities && Object.keys(entities).length) {
            const entityName = this.allIntents[intent].withentity ? this.allIntents[intent].withentity.type : '';
            if (entityName && entities[entityName]) {
              this.message = this.allIntents[intent].withentity[lang].replace('%s', entities[entityName][0].value);
              return;
            }
            this.message = this.allIntents[intent].withoutentity[lang];
            return;
          }
          this.message = this.allIntents[intent].withoutentity[lang];
          return;
        }
        this.message = botMessage;
      }
    },
    data() {
      return {
        intent: '',
        message: '',
        newIntent: '',
        showNewIntentField: false
      };
    },
    mounted() {
      this.intent = this.botIntent;
      this.showMessage(this.entities, this.bot, this.botIntent);
    },
    watch: {
      intent() {
        if (this.intent === 'other') {
          this.showNewIntentField = true;
          return;
        }
        this.showNewIntentField = false;
        this.showMessage(this.entities, this.bot, this.intent);
      }
    },
    computed: mapState({
      allIntents: state => state.general.intentMessages
    })
  };
</script>



// WEBPACK FOOTER //
// src/components/chat/bot.vue